var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      fancy: "",
                      decimals: 2,
                      label: _vm.$ct("margin.top"),
                    },
                    model: {
                      value: _vm.value.Top,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Top", $$v)
                      },
                      expression: "value.Top",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      fancy: "",
                      decimals: 2,
                      label: _vm.$ct("margin.right"),
                    },
                    model: {
                      value: _vm.value.Right,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Right", $$v)
                      },
                      expression: "value.Right",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      fancy: "",
                      decimals: 2,
                      label: _vm.$ct("margin.bottom"),
                    },
                    model: {
                      value: _vm.value.Bottom,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Bottom", $$v)
                      },
                      expression: "value.Bottom",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      fancy: "",
                      decimals: 2,
                      label: _vm.$ct("margin.left"),
                    },
                    model: {
                      value: _vm.value.Left,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Left", $$v)
                      },
                      expression: "value.Left",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }